<mat-dialog-content>
    <div class="flex-row flex-space-between p-20 bg-accent">
        <div>
            <mat-card-header>
                <mat-card-title>
                    Levels
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon class="accent-text">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="p-20">
        <p>
            Levels are based on the points you collect in the community. You move through the numbered levels as you
            earn
            points becoming an active community member.
        </p>
        @if (level?.is_active) {
            <p>
                Your level progress bar is also shown below. The text on the left of the bar tells you that you are on
                <b>{{ level.name }}</b>. The text on the right tells you how many points you need before you level up.
                There is an indicator to show how many points you currently have - in this case
                <b>{{ currentPoints }}</b>,
                and a
                progress bar that shows how you are progressing towards the next level.
            </p>
        }
        <div class="flex-row flex-space-between my-10">
            <small>{{ level?.name }}</small>
        </div>
        <div class="customProgress">
            <div class="customProgress">
                <p [style.color]="this.themeService.getReadableColor(this.color)"
                   class="current">
                    {{ this.level?.starting_points }}
                </p>
                <mat-progress-bar [mode]="'determinate'" [style.border-color]="this.color"
                                  [value]="getPercent(currentPoints, (this.level?.ending_points || 1))"
                                  class="customProgress levelsBar"></mat-progress-bar>
                @if (this.level?.ending_points) {
                    <p class="required">{{ this.level?.ending_points }}</p>
                }
            </div>
        </div>
    </div>
</mat-dialog-content>
